<div class="modal-header">
  <h3 class="modal-title">
    {{ title }}
    <i (click)="cancel()" class="fa fa-times pull-right"></i>
    <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
      style="margin-right: 10px" (click)="minimise = !minimise"></i>
  </h3>
</div>
<div class="modal-body" [hidden]="minimise">
  <div class="entity-info">
    <h3>
      <span class="LayerLine1">Entity:</span>
      <span class="LayerData1">{{ partnerShipObj.entity_name + " : " + partnerShipObj.tax_year_begin + " - " +
        partnerShipObj.tax_year_end }}</span>
    </h3>
    <h3>
      <span class="LayerLine1">Tax Code:</span>
      <span class="LayerData1">{{ partnerShipObj.tax_code }}</span>
    </h3>
    @if (issue_description != '') {
<h3>
      <span class="LayerLine1">Issue:</span>
      <span class="LayerData1">{{ issue_description }}</span>
    </h3>
}
  </div>
  <div>
    <form id="screenFrom" class="form-horizontal" novalidate>
      <div class="modal-body no-body-scroll">
        @if (loadingData) {
<div class="text-center">
          <i class="fa fa-spinner fa-pulse fa-2x"></i>
        </div>
}
        @if (!loadingData) {
<div class="row">
          <div class="row">
            <div class="col-md-12">
              <div id="form_header" class="BlackSmHdrBC">
                {{ formHeader && formHeader.length > 0 ? formHeader[0].DESCRIPTION : '' }}
              </div>
              <div id="allocate_btn" class="all_btn">
                <button class="btn btn-info btn-sm" type="button" (click)="allocate()">Allocate</button>
              </div>
              <div style="padding-top: 0 !important; overflow: auto; height: 65vh;">
                <table style="width: 100%;">
                  <tbody>
                    <tr>
                      <td>
                        <div id="table_container" class="table-scroll">
                          <table class="table table-bordered customTable">
                            <thead>
                              <!-- TABLE 1 -->
                              <tr>
                                <th id="F1065_lineNo" class="sticky-col headerAlign">{{ tableHeader &&
                                  tableHeader.length > 0 ? tableHeader[0].LINE_NO : '' }}</th>
                                <th id="F1065_lineDesc" class="sticky-col headerALign">{{ tableHeader &&
                                  tableHeader.length > 0 ? tableHeader[0].DESCRIPTION : '' }}</th>
                                @for (val of tableHeader; track $index; let i = $index) {
<th [id]="'F1065_attribDesc_' + i"
                                  class="sticky-col headerALign">
                                  {{ val.ATTRIB_DESCRIPTION }}
                                </th>
}
                              </tr>
                            </thead>
                            <tbody>
                              @if (loadingTableData) {
<tr class="table-loading">
                                <td [attr.colspan]="Math.max((tableHeader.length || 0) + 2, 5)" class="text-center"
                                  style="padding: 40px;">
                                  <div class="table-spinner">
                                    <i class="fa fa-spinner fa-pulse fa-2x text-primary"></i>
                                    <div style="margin-top: 10px; color: #666;">Loading table data...</div>
                                  </div>
                                </td>
                              </tr>
}
                              @for (row of outerList | filterAny: { IS_FORM_DISPLAY : 'Y' }: true; track formLineKey(row); let i = $index) {
<tr
                               
                                class="table1">
                                @if (row.ROW_TYPE != 'PH') {
<td [id]="'lineNoM2K1_' + (i + 1)">{{ row.LINE_DISP }}</td>
}
                                @if (row.ROW_TYPE != 'PH') {
<td [id]="'lineDescM2K1_' + (i + 1)">{{ row.DESCRIPTION }}
                                </td>
}
                                @for (row1 of formList; track itemTracker(row1)) {

                                  @if (row1.FORM_LINE_KEY == row.FORM_LINE_KEY) {
<td [id]="'inputM2K1_' + (i + 1)" style="min-width: 200px;"
                                   >

                                    @if (row1.IS_EDITABLE_CELL == 'N') {
<div style="text-align: right; padding-right: 5px;"
                                     
                                      [ngClass]="{'color-red': row1.ATTRIB_VALUE < 0}">
                                      <span [id]="'noteditable_' + (i + 1)">{{ row1.ATTRIB_VALUE | numberWithCommas
                                        }}</span>
                                    </div>
}
                                    @if (row1.IS_EDITABLE_CELL == 'Y') {
<div style="text-align: right; padding-right: 5px;"
                                     >
                                      @if (row1.DATA_TYPE == 'number') {
<div>
                                        <input [id]="'editable_' + (i + 1)" class="form-control input-md numText"
                                          style="text-align: right" type="text" [value]="row1.ATTRIB_VALUE"
                                          (input)="onInputChange($event, row1)" (keypress)="onKeyPress($event)"
                                          (paste)="onPaste($event)" [disabled]="row1.is_editable" placeholder=""
                                          aria-describedby="basic-addon2" />
                                      </div>
}
                                    </div>
}
                                  </td>
}
                                
}
                              </tr>
}
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
}
      </div>
    </form>
  </div>
</div>

<div class="modal-footer">
  @if (!batchSelect) {
<button [id]="'CRD_' + activeTab + '_SAVE_1'" class="btn btn-info btn-sm" type="button"
    (click)="save()" [disabled]="isSaveClicked">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
}

  <button [id]="'CRD_' + activeTab + '_RESET_1'" class="btn btn-danger-outline btn-sm" type="button" (click)="reset()">
    Reset
  </button>
  @if (batchSelect) {
<button [id]="'CRDBS_' + activeTab + '_CLOSEFRM_1'" class="btn btn-warning btn-sm" type="button"
    ng-really-click [ngReallyMessage]="'Are you sure to close the form {{activeTab}} ?'" [ngReallyHeader]="'Close Form'"
    (reallyOkay)="cancelForm()">
    Close Form
  </button>
}
  @if (!batchSelect) {
<button [id]="'CRD_' + activeTab + '_CANCEL_1'" class="btn btn-warning btn-sm" type="button"
    (click)="cancel()">
    Cancel
  </button>
}
</div>